import { useErrorBoundary } from 'react-error-boundary';
import { Controller, useFormContext } from 'react-hook-form';
import { DiagnosisEditFormStateType } from 'types/page/diagnosisEditFormStateType';
import { QuizEditFormStateType } from 'types/page/quizEditFormStateType';

/**
 * コンテンツ作成編集 デザイン設定コンポーネント
 */
export default function WsContentEditDesign(props: {
  readOnly: boolean;
  contentCategory: { label: string; value: number };
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */
  const { showBoundary } = useErrorBoundary();

  const formContext = useFormContext();
  let typedFormContext;
  if (props.contentCategory.label === 'クイズ') {
    typedFormContext = formContext as unknown as ReturnType<
      typeof useFormContext<QuizEditFormStateType>
    >;
  } else if (props.contentCategory.label === '診断') {
    typedFormContext = formContext as unknown as ReturnType<
      typeof useFormContext<DiagnosisEditFormStateType>
    >;
  } else {
    throw new Error('無効なコンテンツカテゴリ');
  }
  const { control } = typedFormContext;
  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const name =
    {
      クイズ: 'quizTemplateId',
      診断: 'diagnosisTemplateId',
    }[props.contentCategory.label] || '';

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   *　デザイン選択時の処理
   */
  const onRadioClick = (selectedValue: number, onChange: (...event: any[]) => void) => {
    try {
      onChange(selectedValue);
    } catch (e) {
      showBoundary(e);
    }
  };

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue={null}
        render={({ field: { onChange, value } }) => {
          return (
            <>
              <section className="section-form-default section-choose-design">
                <div className="container">
                  <div className="box-common">
                    <h3 className="title-section">デザインを選ぼう</h3>

                    <div className="row row-6">
                      <div className="col-md-3">
                        <input
                          type="radio"
                          name="designs"
                          defaultValue="シンプル"
                          id="design1"
                          className="radio-select"
                          defaultChecked={value == 1}
                          onClick={() => onRadioClick(1, onChange)}
                          disabled={props.readOnly}
                        />
                        <label htmlFor="design1" className="label-select">
                          <span className="label-select-title">シンプル</span>
                          <span className="label-select-img-container">
                            <img
                              src="/img/create/design/1.jpg"
                              alt="シンプル"
                              className="label-select-img"
                            />
                          </span>
                        </label>
                      </div>
                      <div className="col-md-3">
                        <input
                          type="radio"
                          name="designs"
                          defaultValue="かわいい"
                          id="design2"
                          className="radio-select"
                          defaultChecked={value == 2}
                          onClick={() => onRadioClick(2, onChange)}
                          disabled={props.readOnly}
                        />
                        <label htmlFor="design2" className="label-select">
                          <span className="label-select-title">かわいい</span>
                          <span className="label-select-img-container">
                            <img
                              src="/img/create/design/2.jpg"
                              alt="かわいい"
                              className="label-select-img"
                            />
                          </span>
                        </label>
                      </div>
                      <div className="col-md-3">
                        <input
                          type="radio"
                          name="designs"
                          defaultValue="モダン"
                          id="design3"
                          className="radio-select"
                          defaultChecked={value == 3}
                          onClick={() => onRadioClick(3, onChange)}
                          disabled={props.readOnly}
                        />
                        <label htmlFor="design3" className="label-select">
                          <span className="label-select-title">モダン</span>
                          <span className="label-select-img-container">
                            <img
                              src="/img/create/design/3.jpg"
                              alt="モダン"
                              className="label-select-img"
                            />
                          </span>
                        </label>
                      </div>
                      <div className="col-md-3">
                        <input
                          type="radio"
                          name="designs"
                          defaultValue="ユーモア"
                          id="design4"
                          className="radio-select"
                          defaultChecked={value == 4}
                          onClick={() => onRadioClick(4, onChange)}
                          disabled={props.readOnly}
                        />
                        <label htmlFor="design4" className="label-select">
                          <span className="label-select-title">ユーモア</span>
                          <span className="label-select-img-container">
                            <img
                              src="/img/create/design/4.jpg"
                              alt="ユーモア"
                              className="label-select-img"
                            />
                          </span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </>
          );
        }}
      />
    </>
  );
}
